import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiConfig, getApiUrl } from 'src/config/apiConfig';
import axiosIn from 'src/middlewares/axiosInterceptor';

const initialState: any = {
  fetchedTableData: {
    // TODO : Implemented also in appGeneralReducer. This is not in use. But tables require this.
    tabId_ports: [],
  },
  currentPaginationOfTabs: {
    tabId_ports: 0,
  },
  currentPageSizeOfTabs: {
    tabId_ports: 25,
  },
  currentTab: 'tabId_ports',

  searchForm: {},

  actionButtonStates: { filter: { show: false, data: {} }, order: { show: false, data: {} }, plus: { show: false, data: {} } },
};

export const PortsPageSlice: any = createSlice({
  name: 'PortsPageSlice',
  initialState,
  reducers: {
    setCurrentTab: (state, action) => {
      state.currentTab = action.payload;
    },
    setPortsSearchForm: (state, action) => {
      const { key, value } = action.payload;
      state.searchForm[key] = value;
    },
    setDataForTab: (state, action) => {
      const { tabId, res } = action.payload;
      state.fetchedTableData[tabId] = res;
    },
    targetsClearForm: (state) => {
      state.searchForm = {};
    }, 
  },
  extraReducers: (builder) => {},
});

export const {
  //
  setPortsSearchForm,
  setCurrentTab, 
  setDataForTab,
  targetsClearForm,
} = PortsPageSlice.actions;

export default PortsPageSlice.reducer;
